import React from 'react';

// Decorative leaf, drawn inline so it costs no request and inherits
// currentColor. Shared by the homepage sections that scatter leaves behind
// their content (About, Wholesale, Footer). Always decoration: callers place
// it inside an aria-hidden / pointer-events-none layer.
const DecorLeaf = ({ className = '', style }) => (
  <svg viewBox="0 0 24 24" className={className} style={style} aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M21 3c0 8.5-4.9 14-11.2 14H7.4c.5-4.2 2.9-7 7.1-9.3-4.7 1.5-7.8 4.4-8.9 9.3-.5 2-.7 3.3-.7 4h-2c0-1 .2-2.4.8-4.7C5 9.2 11.4 3.8 21 3Z"
    />
  </svg>
);

export default DecorLeaf;
